<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box" v-if="ay_std_div_list != null">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong> Elective Subject Registration Report </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_ay_data"
                        return-object
                        :items="ay_std_div_list"
                        item-text="ay"
                        label="Select Academic Year"
                        outlined
                        @change="getStd()"
                        @click="putnull"
                        persistent-hint
                        hint="Please Select Academic Year"
                    />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="sel_std_data"
                        return-object
                        :items="std_div_list"
                        item-text="std"
                        label="Standard"
                        outlined
                        @change="
              getDiv();
              getSub();
            "
                        @click="
              putnull();
              putsub();
            "
                        persistent-hint
                        hint="Please Select Standard"
                    />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list" item-text="div_name" label="Division" outlined @click="putnull()" persistent-hint hint="Please Select Division" />
                </v-col>
                <v-col sm="2" v-if="subject_list != ''">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        multiple
                        dense
                        rounded
                        required
                        v-model="subject"
                        item-value="crs_id"
                        :items="subject_list"
                        item-text="crs_name"
                        label="Select Subject"
                        outlined
                        @click="putnull"
                        persistent-hint
                        hint="Please Select Subject"
                    />
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="status" :items="status_list" item-text="name" item-value="id" label="Status" outlined persistent-hint hint="Select Status"  @click="putnull()" />
                </v-col>
                <v-col sm="2" v-if="sel_ay_data && sel_std_data && div && subject.length > 0">
                    <v-btn class="mt-6 button" @click="getlearners()" :loading="fetch_loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-col cols="12" sm="12" md="12" v-if="learner_info != ''" class="">
                <!-- <v-col sm="2">
                    <v-btn rounded  color="success" outlined @click="ExportToExcel();" :loading="loader"><v-icon   color="success">mdi-export</v-icon>Export</v-btn>
                </v-col> -->
                <v-row dense v-if="learner_list != '' ">
                    <v-col cols="12" sm="2" md="2">
                        <v-btn
                            class="ma-2 no-display"
                            rounded
                            color="success"
                            outlined
                            @click="
                fnExcelReport('my-table-id', 'electivesubjectreport')
              "
                            :loading="loader"
                        >
                            <v-icon color="success">mdi-export</v-icon>Export
                        </v-btn>
                    </v-col>
                    <v-col cols="12" sm="2" md="2">
                        <v-btn class="ma-2 no-display" tile outlined color="warning" @click="showLogo()">
                            Hide /Show Logo
                        </v-btn>
                    </v-col>
                    <!-- <v-col cols="12" sm="2" md="2">
            <v-btn
              class="ma-2 no-display"
              tile
              outlined
              color="warning"
              @click="printReport()"
            >
              <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
            </v-btn>
          </v-col> -->
                    <!-- search code Sourabh -->
                    <!-- <v-col cols="12" sm="6" md="6">
            <v-text-field
              class="ma-2 no-display"
              v-model="search"
              append-icon="mdi-magnify"
              label="Search by Student name or by Registration Number"
              single-line
              hide-details
            ></v-text-field>
          </v-col> -->
                </v-row>
                <div id="my-table-id">
                    <div class="scroll">
                        <!-- header code -->
                        <v-simple-table></v-simple-table>
                        <div v-if="org_basic_data">
                            <v-row dense justify="center" v-if="learner_list != '' ">
                                <v-col cols="12" sm="4" md="2" v-if="org_basic_data.trust_logo && show_logo" align="center">
                                    <img :src="org_basic_data.trust_logo" alt="logo" class="trust-logo" />
                                </v-col>
                                <v-col cols="12" sm="4" md="8">
                                    <center>
                                        <h2>
                                            <strong>{{ org_basic_data.trust_name }}</strong>
                                        </h2>
                                        <h3>
                                            <strong>{{ org_basic_data.school_name }} </strong>
                                        </h3>
                                        <span>{{ org_basic_data.address }}</span> <br />
                                        <span>Phone :{{ org_basic_data.phone }} </span> <br />
                                        <span>Email :{{ org_basic_data.email }} </span> <br />
                                        <span>Website :{{ org_basic_data.website }} </span>
                                        <br />
                                    </center>
                                </v-col>
                                <v-col cols="12" sm="4" md="2" v-if="org_basic_data.school_logo && show_logo">
                                    <img :src="org_basic_data.school_logo" alt="logo" class="schl-logo" />
                                </v-col>
                            </v-row>
                        </div>
                        <div class="box" v-if="learner_list != '' ">
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong><center>Student Elective Subject Registration Details</center></strong>
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-col cols="12" sm="12" md="12" v-if="learner_list != '' && learner_list != null">
                                <v-data-table :items-per-page="-1" v-if="learner_list.length > 0" dense :headers="headers2" :items="bookList1" :search="search" class="elevation-1 mytable" @current-items="getFiltered">
                                    <template v-slot:item.subject="{ item }">
                                        <span v-if="item.subject != null">
                                            <span dense justify="center" v-for="(crs, index) in item.subject" :key="crs.crs_id">
                                                {{ index + 1 }}) {{ crs.crs_name }}
                                            </span>
                                        </span>
                                        <v-btn v-else color="red" text x-small> Not Registered </v-btn>
                                    </template>

                                    <template v-slot:top class="pb-5">
                                        <v-row justify="center" align="center" v-if="show_logo">
                                            <tr class="t-row">
                                                <div>
                                                    <th>
                                                        <v-row>
                                                            <!--  <download-excel  class="mr-2 pb-3 pt-2"
                                            :data   = "bookList1"
                                            :fields = "table_fields"
                                            worksheet = "Student_List"
                                            name    = "Student_List.xls">
                                            <v-btn  color="success" outlined rounded > <v-icon dark>mdi-file-excel</v-icon> Export  </v-btn>
                                        </download-excel>  -->
                                                            <span v-for="header in headers2" :key="header.text">
                                                                <span v-if="filters.hasOwnProperty(header.value)">
                                                                    <v-autocomplete
                                                                        class="mr-2 pb-5 pt-2"
                                                                        flat
                                                                        hide-details
                                                                        small
                                                                        rounded
                                                                        dense
                                                                        outlined
                                                                        color="#0F2027"
                                                                        :label="header.text"
                                                                        multiple
                                                                        clearable
                                                                        :items="columnValueList(header.value)"
                                                                        v-model="filters[header.value]"
                                                                    ></v-autocomplete>
                                                                </span>
                                                            </span>
                                                        </v-row>
                                                    </th>
                                                </div>
                                            </tr>
                                        </v-row>
                                    </template>
                                </v-data-table>
                            </v-col>
                        </div>
                    </div>
                </div>
            </v-col>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data() {
            return {
                fetch_loader: false,
                com_sub_loader: false,
                header: null,
                show: false,
                show_logo: true,
                org_basic_data: [],
                search: "",
                overlay: false,
                selected: [],
                snackbar: false,
                ay_std_div_list: null,
                sel_ay_data: null,
                show_tt: false,
                std_div_list: null,
                sel_std_data: null,
                div_list: null,
                div: null,
                snackbar_msg: "",
                color: "",
                snackbar: false,
                learner_list: [],
                subject_list: [],
                subject: [],
                filterArr: [],
                filters: {
                    div: [],
                    registration_number: [],
                    // subject:[]
                },
                table_fields: {
                    "Sr. No": "srno",
                    "Academic Year": "ay",
                    "PRN. Number": "registration_number",
                    "Roll No": "rollno",
                    "Student Name": "name",
                    Standard: "std",
                    Division: "div",
                    Subject: "subject",
                },
                headers2: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Academic Year",
                        align: "center",
                        sortable: false,
                        value: "ay",
                    },
                    {
                        text: "PRN No.",
                        align: "center",
                        sortable: false,
                        value: "registration_number",
                    },
                    {
                        text: "Roll No",
                        align: "center",
                        sortable: false,
                        value: "rollno",
                    },
                    {
                        text: "Name",
                        align: "center",
                        sortable: false,
                        value: "name",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "std",
                    },
                    {
                        text: "Division",
                        align: "center",
                        sortable: false,
                        value: "div",
                    },
                    {
                        text: "Subject",
                        align: "center",
                        sortable: false,
                        value: "subject",
                    },
                ],
                status_list: [
                    { name: "Active", id: "0" },
                    { name: "Temporary Inactive", id: "1" },
                    { name: "Permanent Inactive", id: "2" },
                ],
                status: null,
            };
        },
        computed: {
            bookList1() {
                return this.learner_list.filter((d) => {
                    return Object.keys(this.filters).every((f) => {
                        return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
                    });
                });
            },
        },
        methods: {
            fnExcelReport(id, name) {
                var tab_text = '<html xmlns:x="urn:schemas-microsoft-com:office:excel">';
                tab_text = tab_text + "<head><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>";
                tab_text = tab_text + "<x:Name>Test Sheet</x:Name>";
                tab_text = tab_text + "<x:WorksheetOptions><x:Panes></x:Panes></x:WorksheetOptions></x:ExcelWorksheet>";
                tab_text = tab_text + "</x:ExcelWorksheets></x:ExcelWorkbook></xml></head><body>";
                tab_text = tab_text + "<table border='1px'>";
                var exportTable = $("#" + id).clone();
                exportTable.find("input").each(function (index, elem) {
                    $(elem).remove();
                });
                tab_text = tab_text + exportTable.html();
                tab_text = tab_text + "</table></body></html>";
                var fileName = name + "_" + parseInt(Math.random() * 10000000000) + ".xls";

                //Save the file
                // var blob = new Blob([tab_text], {
                //     type: "application/vnd.ms-excel;charset=utf-8",
                // });
                // window.saveAs(blob, fileName);
                 const blob = new Blob([tab_text], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const filename = name+'.xls';

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
            },
            showLogo() {
                if (this.show_logo) {
                    this.show_logo = false;
                } else {
                    this.show_logo = true;
                }
            },
            printReport() {
                this.$store.state.drawer = false;
                let that = this;
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
            putsub() {
                // alert("put null")
                this.subject_list = [];
            },
            getFiltered(e) {
                this.filterArr = e;
            },
            columnValueList(val) {
                return this.learner_list.map((d) => d[val]);
            },
            putnull() {
                this.learner_list = [];
            },
            getSub() {
                let ay;
                if (this.sel_ay_data.ay_id) {
                    ay = this.sel_ay_data.ay_id;
                } else if (this.sel_ay_data.id) {
                    ay = this.sel_ay_data.id;
                }
                const data = {
                    ay: ay,
                    standard: this.sel_std_data.std_id,
                };
                axios
                    .post("/Examination/getElectiveSubject", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.subject_list = res.data.course_list;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", res.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = ["All"];
                this.div = "All";
                this.div_list = this.sel_std_data.div_list;
                this.div_list.unshift("All");
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/commonAPI/get_ay_std_div")
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.sel_ay_data = res.data.curr_ay;
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            getlearners() {
                this.fetch_loader = true;
                let ay;
                if (this.sel_ay_data.ay_id) {
                    ay = this.sel_ay_data.ay_id;
                } else if (this.sel_ay_data.id) {
                    ay = this.sel_ay_data.id;
                }
                let div = this.div.div_id;
                if (this.div.div_id) {
                    div = this.div.div_id;
                } else {
                    div = this.div;
                }
                const data = {
                    ay: ay,
                    standard: this.sel_std_data.std_id,
                    division: div,
                    subject: this.subject,
                    status: this.status,
                };
                axios
                    .post("/Examination/getElectiveSubjectReport", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.learner_list = res.data.learner_list;
                            this.org_basic_data = res.data.org_basic_data;
                            this.fetch_loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.fetch_loader = false;
                    })
                    .finally(() => {
                        ay = null;
                        this.fetch_loader = false;
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .radiospace {
        margin: 1rem !important;
        padding: 0%;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
    .t-row {
        padding: 1rem i !important;
    }
    .mytable3 /deep/ thead th {
        background: #0f2027 !important; /* fallback for old browsers */
        background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* Chrome 10-25, Safari 5.1-6 */
        background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important; /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
        background-color: #0f2027 !important;
        color: white !important;
        font-weight: bold !important;
        white-space: nowrap !important;
        text-align: center;
    }
    .delete-avatar {
        transition: 0.3s;
        border: 1px solid red;
        margin: 0.2rem !important;
    }
    .delete-avatar:hover {
        background-color: transparent;
    }
    .delete-v-icon {
        padding-left: 8px;
        padding-top: 1px;
        font-size: 15px;
    }
    .delete-v-icon:hover {
        color: white;
    }
    .v-dialogss {
        bottom: 880;
        right: 0;
    }
    .trust-logo {
        width: 86%;
    }
    .schl-logo {
        width: 86%;
    }
</style>
<!-- abcd -->
